import React, { useState, useContext, useEffect } from "react";
import { Grid, FormControlLabel, Checkbox } from "@material-ui/core";
import { BrowserView, MobileView } from "react-device-detect";
import FlexView from "react-flexview/lib";
import { SessionContextStore } from "../../../context/SessionContext";
import {
  EventEmitterService,
  EventKey,
} from "../../../services/EventEmitterService";
import "../UserProfile.scss";
import {
  ACTIONS,
  UserProfileContextStore,
} from "../../../context/UserProfileContext";
import { Action } from "../../../models/Action";
import generalApi from "../../../api/general.api";
import { ReactComponent as AddSvg } from "../../../assets/add.svg";
import { ReactComponent as MinusSvg } from "../../../assets/minus.svg";
import { MembershipCourseSubSection } from "./MembershipCourseSubSection";
import { useForm } from "react-hook-form";

export const MembershipCourseSection = (props) => {
  const context = useContext(UserProfileContextStore);
  const sessionContext = useContext(SessionContextStore);

  const {
    register,
    watch,
    triggerValidation,
    setValue,
    errors,
    control,
    getValues,
    reset,
  } = useForm({
    mode: "onChange",
  });
  const [membershipsCourses, setmembershipsCourses] = useState([]);
  const [counter, setCounter] = useState([0]);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    var membershipCourses = async () => {
      const membershipCourses = await generalApi.getMembershipsAndCourses();
      setmembershipsCourses(membershipCourses.data);
    };
    membershipCourses();
  }, []);

  useEffect(() => {
    context.dispatch(
      new Action(ACTIONS.MEMBERSHIP_COURSE_COUNT, counter.length)
    );
  }, [counter]);

  React.useEffect(() => {
    let id = EventEmitterService.subscribe(
      EventKey.USER_PROFILE_SAVE,
      async () => {
        const values = getValues();

        context.dispatch(
          new Action(
            ACTIONS.MEMBERSHIP_COURSE_AGREE,
            values.membershipCourseAgree
          )
        );
      }
    );

    return function cleanup() {
      EventEmitterService.unsubscribe(EventKey.USER_PROFILE_SAVE, id);
    };
  }, []);

  useEffect(() => {
    reset({
      membershipCourseAgree: sessionContext.user.membershipsCoursesAgree,
    });
    setChecked(sessionContext.user.membershipsCoursesAgree);
  }, [sessionContext.user.membershipsCoursesAgree]);

  useEffect(() => {
    setValue("membershipCourseAgree", checked);
  }, [checked]);

  useEffect(() => {
    setCounter(
      sessionContext.user.membershipsCourses?.length === 2 ? [0, 1] : [0]
    );
  }, [sessionContext.user.membershipsCourses]);

  const toggleAddRemove = () => {
    if (counter.length === 2) {
      setCounter([0]);
      context.dispatch(new Action(ACTIONS.DELETE_MEMBERSHIP_COURSE, 1));
    } else {
      setCounter([0, 1]);
    }
  };

  return (
    <React.Fragment>
      {!!membershipsCourses.length &&
        counter.map((idx) => {
          return (
            <MembershipCourseSubSection
              key={idx}
              membershipCoursesList={membershipsCourses}
              membershipsCourse={sessionContext.user.membershipsCourses[idx]}
              idx={idx}
              agree={watch("membershipCourseAgree")}
            />
          );
        })}
      <Grid item xs={12} md={6}>
        <FlexView
          className="margin-bottom-small margin-top-small clickable"
          onClick={toggleAddRemove}
          vAlignContent={"center"}
        >
          {counter.length === 1 && <AddSvg className="add blue-svg-path" />}
          {counter.length === 2 && <MinusSvg className="add blue-svg-path" />}

          <span className="text-body blue">
            {counter.length === 1 ? "Add a second entity" : "Remove second entity"}
          </span>
        </FlexView>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onClick={(x) => setChecked(x.target.checked)}
              name="membershipCourseAgree"
              inputRef={register}
              color="primary"
            />
          }
          label="I confirm that my course completion and/or membership information is accurate."
        />
      </Grid>
    </React.Fragment>
  );
};
